import { StateModel, IStateModel } from '@common/models/StateModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class StateService {
  private static baseUrl: string = '/api/state';
  static tags = {
    upsertState: 'upsertState',
    getStates: 'getStates',
  };

  static getStates = (
    options?: ServiceMethodOptions,
  ): Promise<StateModel[]> => {
    return trackPromise(
      new Promise<StateModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<IStateModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('State fetched.', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get State.', options);
            reject(err);
          });
      }),
      this.tags.getStates,
    );
  };

  static upsertState = (
    data: IStateModel,
    options?: ServiceMethodOptions,
  ): Promise<StateModel> => {
    return trackPromise(
      new Promise<IStateModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IStateModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('State updated.', options);
            resolve(new StateModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update State.', options);
            reject(err);
          });
      }),
      this.tags.upsertState,
    );
  };
}
